/* @flow */
'use strict';
/* :: import type {Callback, Batch, Query, QueryResult, QueryEntry} from 'interface-datastore' */

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var pull = require('pull-stream');

var levelup = require('levelup');

var asyncFilter = require('interface-datastore').utils.asyncFilter;

var asyncSort = require('interface-datastore').utils.asyncSort;

var Key = require('interface-datastore').Key;

var Errors = require('interface-datastore').Errors;

var encode = require('encoding-down');
/**
 * A datastore backed by leveldb.
 */

/* :: export type LevelOptions = {
  createIfMissing?: bool,
  errorIfExists?: bool,
  compression?: bool,
  cacheSize?: number,
  db?: Object
} */


var LevelDatastore =
/*#__PURE__*/
function () {
  /* :: db: levelup */
  function LevelDatastore(path
  /* : string */
  , opts
  /* : ?LevelOptions */
  ) {
    _classCallCheck(this, LevelDatastore);

    var database;

    if (opts && opts.db) {
      database = opts.db;
      delete opts.db;
    } else {
      // Default to leveldown db
      database = require('leveldown');
    }

    this.db = levelup(encode(database(path), {
      valueEncoding: 'binary'
    }), Object.assign({}, opts, {
      compression: false // same default as go

    }), function (err) {
      // Prevent an uncaught exception error on duplicate locks
      if (err) {
        throw err;
      }
    });
  }

  _createClass(LevelDatastore, [{
    key: "open",
    value: function open(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.db.open(function (err) {
        if (err) {
          return callback(Errors.dbOpenFailedError(err));
        }

        callback();
      });
    }
  }, {
    key: "put",
    value: function put(key
    /* : Key */
    , value
    /* : Buffer */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.db.put(key.toString(), value, function (err) {
        if (err) {
          return callback(Errors.dbWriteFailedError(err));
        }

        callback();
      });
    }
  }, {
    key: "get",
    value: function get(key
    /* : Key */
    , callback
    /* : Callback<Buffer> */
    )
    /* : void */
    {
      this.db.get(key.toString(), function (err, data) {
        if (err) {
          return callback(Errors.notFoundError(err));
        }

        callback(null, data);
      });
    }
  }, {
    key: "has",
    value: function has(key
    /* : Key */
    , callback
    /* : Callback<bool> */
    )
    /* : void */
    {
      this.db.get(key.toString(), function (err, res) {
        if (err) {
          if (err.notFound) {
            callback(null, false);
            return;
          }

          callback(err);
          return;
        }

        callback(null, true);
      });
    }
  }, {
    key: "delete",
    value: function _delete(key
    /* : Key */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.db.del(key.toString(), function (err) {
        if (err) {
          return callback(Errors.dbDeleteFailedError(err));
        }

        callback();
      });
    }
  }, {
    key: "close",
    value: function close(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.db.close(callback);
    }
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Buffer> */
    {
      var _this = this;

      var ops = [];
      return {
        put: function put(key
        /* : Key */
        , value
        /* : Buffer */
        )
        /* : void */
        {
          ops.push({
            type: 'put',
            key: key.toString(),
            value: value
          });
        },
        delete: function _delete(key
        /* : Key */
        )
        /* : void */
        {
          ops.push({
            type: 'del',
            key: key.toString()
          });
        },
        commit: function commit(callback
        /* : Callback<void> */
        )
        /* : void */
        {
          _this.db.batch(ops, callback);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Buffer> */
    )
    /* : QueryResult<Buffer> */
    {
      var values = true;

      if (q.keysOnly != null) {
        values = !q.keysOnly;
      }

      var iter = this.db.db.iterator({
        keys: true,
        values: values,
        keyAsBuffer: true
      });

      var rawStream = function rawStream(end, cb) {
        if (end) {
          return iter.end(function (err) {
            cb(err || end);
          });
        }

        iter.next(function (err, key, value) {
          if (err) {
            return cb(err);
          }

          if (err == null && key == null && value == null) {
            return iter.end(function (err) {
              cb(err || true);
            });
          }

          var res
          /* : QueryEntry<Buffer> */
          = {
            key: new Key(key, false)
          };

          if (values) {
            res.value = Buffer.from(value);
          }

          cb(null, res);
        });
      };

      var tasks = [rawStream];
      var filters = [];

      if (q.prefix != null) {
        var prefix = q.prefix;
        filters.push(function (e, cb) {
          return cb(null, e.key.toString().startsWith(prefix));
        });
      }

      if (q.filters != null) {
        filters = filters.concat(q.filters);
      }

      tasks = tasks.concat(filters.map(function (f) {
        return asyncFilter(f);
      }));

      if (q.orders != null) {
        tasks = tasks.concat(q.orders.map(function (o) {
          return asyncSort(o);
        }));
      }

      if (q.offset != null) {
        var i = 0;
        tasks.push(pull.filter(function () {
          return i++ >= q.offset;
        }));
      }

      if (q.limit != null) {
        tasks.push(pull.take(q.limit));
      }

      return pull.apply(null, tasks);
    }
  }]);

  return LevelDatastore;
}();

module.exports = LevelDatastore;